import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { PaymentMethodEnum, ReferralProgramStatusEnum } from "../models/types.mjs";
import { stripeSubscriptionStatusSchema } from "../models/subscription.mjs";
import { subscriptionScheduleStatusSchema } from "../models/subscriptionSchedule.mjs";
import { z as z$1 } from "zod";

// src/paymentMethod/snapshot.ts
const sponsorInfoSnapshotSchema = z$1.object({
	startDate: z$1.any().transform(zodTransformFirestoreTimestampToDate),
	endDate: z$1.any().transform(zodTransformFirestoreTimestampToDate),
	consultationIncluded: z$1.boolean(),
	status: z$1.enum(["active", "expired"]).optional()
});
/** Serializable inputs for computing `PaymentMethod` at a given `now` (no time baked in). */
const paymentMethodInputSnapshotSchema = z$1.object({
	paymentMethodKind: z$1.nativeEnum(PaymentMethodEnum),
	hasSignupPayment: z$1.boolean(),
	signupPaymentEndDate: z$1.union([z$1.null(), z$1.any().transform(zodTransformFirestoreTimestampToDate)]).optional(),
	trialStartDate: z$1.union([z$1.null(), z$1.any().transform(zodTransformFirestoreTimestampToDate)]).optional(),
	trialEndDate: z$1.union([z$1.null(), z$1.any().transform(zodTransformFirestoreTimestampToDate)]).optional(),
	hasSubscription: z$1.boolean(),
	subscriptionStatus: stripeSubscriptionStatusSchema.nullable().optional(),
	sponsorInfo: sponsorInfoSnapshotSchema.nullable(),
	productName: z$1.string().nullable(),
	stripeProductId: z$1.string().nullable().optional(),
	stripeProductConsultation: z$1.boolean().nullable().optional(),
	subscriptionScheduleStatus: subscriptionScheduleStatusSchema.nullable().optional(),
	signupFlowCompleted: z$1.boolean().optional()
});
function extractPaymentMethodInputSnapshot(args) {
	const { paymentMethodKind, signupPaymentInfo, signupFlowCompleted, trialInfo, subscription, sponsorInfo, product, subscriptionSchedule } = args;
	const signupPaymentEndDate = signupPaymentInfo?.endDate ? signupPaymentInfo.endDate instanceof Date ? signupPaymentInfo.endDate : new Date(signupPaymentInfo.endDate) : null;
	return {
		paymentMethodKind,
		hasSignupPayment: !!signupPaymentInfo,
		signupPaymentEndDate: signupPaymentEndDate ?? void 0,
		trialStartDate: trialInfo?.startDate ?? void 0,
		trialEndDate: trialInfo?.endDate ?? void 0,
		hasSubscription: !!subscription,
		subscriptionStatus: subscription?.subscriptionInfo?.stripeStatus ?? null,
		sponsorInfo: sponsorInfo?.startDate && sponsorInfo.endDate && sponsorInfo.consultationIncluded != null ? {
			startDate: sponsorInfo.startDate,
			endDate: sponsorInfo.endDate,
			consultationIncluded: sponsorInfo.consultationIncluded,
			status: sponsorInfo.status
		} : null,
		productName: product?.name ?? null,
		stripeProductId: product?.stripeProductId ?? void 0,
		stripeProductConsultation: product?.consultation ?? false,
		subscriptionScheduleStatus: subscriptionSchedule?.status ?? void 0,
		signupFlowCompleted
	};
}

export { extractPaymentMethodInputSnapshot, paymentMethodInputSnapshotSchema };
//# sourceMappingURL=snapshot.mjs.map